import React, { ReactElement, useEffect, useState } from 'react';
import { Animated } from 'react-native';

import Spacing from '../../theming/Spacing';
import KitLoader from '../KitLoader';

export default ({
  animationDuration = 500,
  callback = () => null,
  marginBottom = Spacing.xxl,
  marginTop = Spacing.xxl,
  show,
  size = Spacing.xxxl,
}: {
  animationDuration?: number;
  callback?: () => void;
  marginBottom?: number;
  marginTop?: number;
  show: boolean;
  size?: number;
}): ReactElement => {
  const [animateHeight] = useState<Animated.Value>(new Animated.Value(0));

  const animate = (show = false) => {
    Animated.timing(animateHeight, {
      duration: show ? 0 : animationDuration,
      toValue: show ? size + marginBottom : 0,
      useNativeDriver: false,
    }).start(callback);
  };

  useEffect(() => {
    animate(show);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <Animated.View
      style={[
        {
          marginTop: marginTop,
          alignItems: 'center',
          height: animateHeight,
          overflow: 'hidden',
        },
      ]}
    >
      <KitLoader size={size} />
    </Animated.View>
  );
};
